import { InjectionToken } from "@angular/core";

export const TOGGLE_DISPLAY_STATE_PROP = new InjectionToken<string>("TOGGLE_DISPLAY_STATE_PROP");
export const toggleDisplayStatePropProvider = {
    provide: TOGGLE_DISPLAY_STATE_PROP,
    useValue: "toggleDisplay",
};
